import React from 'react';
import {FilterSelect} from './FilterSelect';
import {FilterControlWithNegate} from './FilterControlWithNegate';
import {
  SubdivisionCode,
  SubdivisionLabels,
  SubdivisionList,
} from '../../../shared/subdivisions';
import {entries} from '../../../shared/util';
import {CountryList} from '../../../shared/countries';

const groupedOptions = entries(SubdivisionList).map(
  ([countryCode, subdivisions]) => ({
    label: CountryList[countryCode],
    options: entries(subdivisions).map(
      ([code, label]: [SubdivisionCode, string]) => ({
        value: code,
        label,
      })
    ),
  })
);

export const StateFilterControl = ({
  value,
  negate,
  onChange,
  onRemove,
}: {
  value: SubdivisionCode[];
  negate?: boolean;
  onChange: (value: SubdivisionCode[], negate?: boolean) => void;
  onRemove: () => void;
}) => {
  return (
    <FilterControlWithNegate
      value={value}
      negate={negate}
      onChange={onChange}
      onRemove={onRemove}
    >
      {(_, onValueChange) => (
        <FilterSelect
          options={groupedOptions}
          isMulti
          onChange={(values) => {
            onValueChange(values.map((v) => v.value));
          }}
          value={value.map((v) => ({
            value: v,
            label: SubdivisionLabels[v],
          }))}
        />
      )}
    </FilterControlWithNegate>
  );
};
